import { render, staticRenderFns } from "./data-dictionary-panel.component.vue?vue&type=template&id=42eaf518&scoped=true&"
import script from "./data-dictionary-panel.component.vue?vue&type=script&lang=ts&"
export * from "./data-dictionary-panel.component.vue?vue&type=script&lang=ts&"
import style0 from "./data-dictionary-panel.component.vue?vue&type=style&index=0&id=42eaf518&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eaf518",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
